import type { RouteRecordRaw } from "vue-router";

export const accountingRoutes: RouteRecordRaw = {
    path: '/accounting',
    children: [
        //volume
        {
            name: 'Bill',
            path: 'bill',
            component: () => import('./volume/bill/BillPage.vue'),
            meta: { defaultLayout: true, }
        },
        {
            name: 'Volume Client - Unbilled Animals',
            path: 'unbilled-client/:clientId',
            component: () => import('./volume/bill/DetailedExpense.vue'),
            meta: { defaultLayout: true, type: 'unbilled' }
        },
        {
            name: 'Billed Volume Clients',
            path: 'volume-apply-payment',
            component: () => import('./volume/apply-payment/ApplyPayment.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Apply Payment - Multiple Invoices',
            path: 'pay-multiple-invoices/:clientId',
            component: () => import('./volume/apply-payment/PayMultipleInvoices.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Volume Client - Pay Invoice',
            path: 'pay-invoice/:clientId/:invoiceId',
            component: () => import('./volume/apply-payment/PayInvoice.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Recent Invoices',
            path: 'invoices',
            component: () => import('./volume/invoices/InvoicesPage.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Volume Client - Billed Animals',
            path: 'billed-client/:clientId',
            component: () => import('./volume/bill/DetailedExpense.vue'),
            meta: { defaultLayout: true, type: 'billed' }
        },
        {
            name: 'Volume Clients',
            path: 'volume-summary',
            component: () => import('./volume/summary/VolumeSummary.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Client Credit History',
            path: 'credit-summary/:clientId',
            component: () => import('./volume/summary/CreditSummary.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Client Ledger',
            path: 'summary-details/:clientId',
            component: () => import('./volume/summary/SummaryDetails.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'VC History',
            path: 'volume-payment-history',
            component: () => import('./volume/history/VolumeHistory.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Inovice History',
            path: 'volume-invoice-history',
            component: () => import('./volume/invoice-history/InvoiceHistory.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Accounts Receivable for VCs',
            path: 'accounts-receivable',
            component: () => import('./volume/accounts-receivable/AccountReceivable.vue'),
            meta: { defaultLayout: true }
        },
        //donation
        {
            name: 'Take Donation',
            path: 'donations',
            component: () => import('./donation/DonationPage.vue'),
            meta: { defaultLayout: true }
        },
        //public
        {
            name: 'Apply Payment',
            path: 'public-clients',
            component: () => import('./public/apply-payment/ApplyPayment.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Apply Payment For Public Client',
            path: 'public-clients/:clientId',
            component: () => import('./public/apply-payment/PublicClient.vue'),
        },
        {
            name: 'Credit Balances',
            path: 'credit-balances',
            component: () => import('./public/public-ledger/PublicLedger.vue'),
            meta: { defaultLayout: true }
        },
        //item sale
        {
            name: 'Item Sales',
            path: 'item-sales',
            component: () => import('./item-sales/ItemSales.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Sale',
            path: 'item-sales/new',
            component: () => import('./item-sales/SalesCreate.vue'),
            meta: { defaultLayout: true }
        },
        //tools
        {
            name: 'Tools',
            path: 'tools',
            component: () => import('./tools/UnpayInvoice.vue'),
            meta: { defaultLayout: true }
        },
        //reports
        {
            name: 'Reconciliation',
            path: 'reconciliation',
            component: () => import('./reports/reconciliation/Reconciliation.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Financial Export',
            path: 'financial-export',
            component: () => import('./reports/financial-export/FinancialExport.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Deleted Payments Log',
            path: 'voided-payments-log',
            component: () => import('./reports/voided-payments-log/VoidedPaymentsLog.vue'),
            meta: { defaultLayout: true }
        },
    ]
};